var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Divider } from '@mui/material';
import { DialogTypes } from 'common/enums/components/dialog-types.enum';
import { USER } from 'common/graphql/queries/user/user';
import Button from 'components/Buttons/Button';
import CircularProgressMui from 'components/Loading/CircularProgresMui';
import UserAvatar from 'components/UserAvatar/UserAvatar';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openDialog } from 'store/actions';
import SettingsForm from '../components/SettingsForm/SettingsForm';
var DeleteUserAccount = function () {
    var _a, _b;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _c = useQuery(USER, {
        variables: {
            showMainSettings: true
        }
    }), data = _c.data, loading = _c.loading;
    var handleClick = function (userId, userFullName) {
        dispatch(openDialog({
            dialogType: DialogTypes.DeleteUserAccount,
            dialogProps: {
                userId: userId,
                userFullName: userFullName
            }
        }));
    };
    if (loading)
        return _jsx(CircularProgressMui, {}, void 0);
    return (_jsx(SettingsForm, { header: _jsx(_Fragment, { children: t('Удаление аккаунта') }, void 0), content: _jsxs(_Fragment, { children: [_jsx(Divider, { light: true }, void 0), _jsxs("div", __assign({ className: "flex flex-col space-y-20 items-start w-full pt-20" }, { children: [_jsx("p", { children: t('deleteUserAccountText') }, void 0), data && (_jsxs("div", __assign({ className: "flex flex-col space-y-10 w-full items-center justify-center" }, { children: [_jsxs("div", __assign({ className: "flex flex-row space-x-5 items-center" }, { children: [_jsx(UserAvatar, { style: "w-36 h-36", profilePhoto: { url: ((_b = (_a = data.user.mainSettings) === null || _a === void 0 ? void 0 : _a.profilePhoto) === null || _b === void 0 ? void 0 : _b.url) || '' }, firstName: data.user.mainSettings.firstName }, void 0), _jsxs("p", __assign({ className: "text-16" }, { children: [_jsx("span", { children: data.user.mainSettings.firstName }, void 0), ' ', _jsx("span", { children: data.user.mainSettings.lastName }, void 0)] }), void 0)] }), void 0), _jsx(Button, __assign({ type: "red", onClick: function () {
                                        handleClick(data.user.id, "".concat(data.user.mainSettings.firstName, " ").concat(data.user.mainSettings.lastName));
                                    } }, { children: t('Удалить') }), void 0)] }), void 0))] }), void 0)] }, void 0) }, void 0));
};
export default DeleteUserAccount;
